export const speaking = [
  {
    name: 'Microsoft Ignite 2022 - Collaborative Whiteboard App Showcase',
    year: 2022,
    location: 'Microsoft Ignite Conference',
    url: 'https://ignite.microsoft.com/',
  },
  {
    name: 'Real-Time Analytics Platform Development',
    year: 2023,
    location: 'Printer Dealership Industry',
    url: '#',
  },
  {
    name: 'Cybersecurity Dashboard Suite Architecture',
    year: 2022,
    location: 'Enterprise Security Solutions',
    url: '#',
  },
  {
    name: 'Performance Optimization - 5x FPS Improvement',
    year: 2022,
    location: 'Bontouch Projects',
    url: '#',
  },
];

export const interviews = [
  {
    name: 'Building Scalable Web Applications',
    year: 2023,
    location: 'Technical Blog',
    url: '#',
  },
  {
    name: 'From Consultant to Full-Stack Expert',
    year: 2022,
    location: 'Developer Interview',
    url: '#',
  },
  {
    name: 'Modern Web Development Best Practices',
    year: 2021,
    location: 'Tech Podcast',
    url: '#',
  },
  {
    name: 'Cross-Platform Development Strategies',
    year: 2021,
    location: 'Industry Publication',
    url: '#',
  },
];

export const achievements = [
  {
    name: 'Microsoft Teams App Development',
    year: 2022,
    location: 'Bontouch',
    description: 'Architected collaborative whiteboard app showcased at Microsoft Ignite 2022',
  },
  {
    name: 'Real-Time Analytics Platform',
    year: 2023,
    location: 'Hagatun IT',
    description: 'Led development of analytics platform that significantly boosted partner margins and enhanced customer retention through actionable insights',
  },
  {
    name: 'Performance Optimization Expert',
    year: 2022,
    location: 'Multiple Projects',
    description: 'Consistently achieved 5x+ performance improvements across applications',
  },
  {
    name: 'Full-Stack Consulting Success',
    year: 2019,
    location: 'Hagatun IT',
    description: '5+ years of successful consulting across startups, SMEs, and enterprise',
  },
];

export const certifications = [
  {
    name: 'Certified IT-Engineer',
    year: 2021,
    location: 'Kattegattgymnasiet, Halmstad',
    description: 'Upper Secondary School certification in IT Engineering',
  },
  {
    name: 'AWS Cloud Solutions',
    year: 2022,
    location: 'Amazon Web Services',
    description: 'Professional development in cloud infrastructure',
  },
  {
    name: 'React & TypeScript Specialist',
    year: 2020,
    location: 'Professional Development',
    description: 'Advanced certification in modern JavaScript frameworks',
  },
];

export const projects = [
  {
    name: 'Cybersecurity Dashboard Suite',
    year: 2023,
    technologies: 'React, TypeScript, Express, Redis, BullMQ',
    description: 'Scalable monorepo with multiple full-stack applications',
  },
  {
    name: 'Multilingual CMS Platforms',
    year: 2022,
    technologies: 'Next.js, Sanity CMS, TailwindCSS, Prisma',
    description: 'SEO-optimized websites for nonprofit, retail, and educational clients',
  },
  {
    name: 'Canvas Configurators',
    year: 2021,
    technologies: 'Canvas API, D3.js, WebGL, PDF generation',
    description: 'Business-critical tools for MedTech, Energy, and manufacturing',
  },
  {
    name: 'Data Visualization Dashboards',
    year: 2021,
    technologies: 'D3.js, Canvas API, WebSockets, React',
    description: 'Real-time insights and interactive data exploration',
  },
];
